import { render, staticRenderFns } from "./PoiDirections.vue?vue&type=template&id=ce51176e&"
import script from "./PoiDirections.vue?vue&type=script&lang=js&"
export * from "./PoiDirections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiDirections.vue"
export default component.exports